import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import { Alert, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { DataTable, DataTableColumnProvider } from '../DataTable/DataTable';
var EntityPage = /** @class */ (function (_super) {
    __extends(EntityPage, _super);
    function EntityPage(props) {
        var _this = _super.call(this, props) || this;
        _this.save = _this.save.bind(_this);
        _this.deleteOne = _this.deleteOne.bind(_this);
        _this.state = {
            modalState: false,
            modalError: '',
            error: ''
        };
        return _this;
    }
    EntityPage.prototype.save = function (values) {
        var _this = this;
        var entityService = this.props.entityService;
        return new Promise(function (resolve, reject) {
            //@ts-ignore
            var isNew = values.new || !values.itemId;
            //@ts-ignore
            var savePromise = isNew ? entityService.create(values) : entityService.update(values.itemId, values);
            savePromise
                .then(function (response) {
                console.log('created', response.data);
                _this.setState(__assign(__assign({}, _this.state), { modalState: false }));
                resolve(response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    EntityPage.prototype.deleteOne = function (values) {
        var _this = this;
        var _a = this.props, entityKeyField = _a.entityKeyField, afterDelete = _a.afterDelete, onDeleteError = _a.onDeleteError, entityService = _a.entityService;
        var entityId = values[entityKeyField];
        if (entityId) {
            entityService
                .delete(entityId)
                .then(function (response) {
                console.log(response);
                afterDelete();
            })
                .catch(function (error) {
                console.error(error);
                _this.setState(__assign(__assign({}, _this.state), { error: error.message || error.status || error.detail }));
                onDeleteError(error);
            });
        }
    };
    EntityPage.prototype.render = function () {
        var _this = this;
        var Editor = this.props.entityEditor;
        var _a = this.props, title = _a.title, subTitle = _a.subTitle, entityState = _a.entityState, columndescriptions = _a.columndescriptions;
        var _b = this.state, modalError = _b.modalError, modalState = _b.modalState;
        return (React.createElement("div", null,
            title && React.createElement("h3", null, title),
            subTitle && React.createElement("h4", null, subTitle),
            React.createElement(Modal, { isOpen: !!modalState },
                React.createElement(ModalHeader, { toggle: function () {
                        _this.setState(__assign(__assign({}, _this.state), { modalState: false }));
                    } }, "Create One"),
                React.createElement(ModalBody, null, Editor({
                    entity: modalState,
                    save: this.save,
                    cancel: function () {
                        _this.setState(__assign(__assign({}, _this.state), { modalState: false }));
                    }
                })),
                React.createElement(ModalFooter, null, modalError && React.createElement(Alert, { color: "danger" }, modalError))),
            React.createElement(DataTable, { entityState: entityState, onCreateClick: function () {
                    return _this.setState(__assign(__assign({}, _this.state), { modalState: entityState.example }));
                }, columnProvider: new DataTableColumnProvider({
                    onDeleteClick: function (values) { return _this.deleteOne(values); },
                    onEditClick: function (values) {
                        _this.setState(__assign(__assign({}, _this.state), { modalState: values }));
                    },
                    columnDescriptions: columndescriptions
                }) })));
    };
    return EntityPage;
}(Component));
export { EntityPage };
//# sourceMappingURL=EntityPage.js.map